import { createClient } from "@supabase/supabase-js";
import { auth } from "../firebase";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl!, supabaseKey!, {
  accessToken: async () => {
    return (
      (await auth.currentUser?.getIdToken(/* forceRefresh */ false)) ?? null
    );
  },
});

// Export WordService implementations
export { SupabaseWordService } from "./SupabaseWordService";
